import { mergeMap, tap } from 'rxjs/operators';
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import { selectTriggersInStore, selectTriggersPageLoading, selectTriggersShowInitWaitingMessage } from '../_selectors/Trigger.selectors';


export class TriggerDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
        super();

		this.loading$ = this.store.pipe(
			select(selectTriggersPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectTriggersShowInitWaitingMessage)
        );
        
        this.store.pipe(
			select(selectTriggersInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});

    }
}